import "core-js/modules/es.array.push.js";
import "@tonWallet/index";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "layout",
  inject: ["reload"],
  data() {
    const menuList = [{
      "name": "首页",
      "path": "/"
    }, {
      "name": "统计",
      "path": "/stat"
    }, {
      "name": "系统邀请",
      "path": "/ref"
    }, {
      "name": "客户邀请",
      "path": "/uref"
    }, {
      "name": "任务",
      "path": "/task"
    }, {
      "name": "广告",
      "path": "/adv"
    }, {
      "name": "其他任务",
      "path": "/validatortask"
    }, {
      "name": "幸运抽奖",
      "path": "/luckylottery"
    }, {
      "name": "礼品列表",
      "path": "/gifts"
    }, {
      "name": "礼品订单",
      "path": "/giftorder"
    }, {
      "name": "资产配置",
      "path": "/assetstokens"
    }, {
      "name": "用户资产",
      "path": "/userassetsstat"
    }, {
      "name": "充值列表",
      "path": "/rechargelist"
    }, {
      "name": "用户列表",
      "path": "/userlist"
    }, {
      "name": "推送任务",
      "path": "/pushtask"
    }, {
      "name": "BotCode排行",
      "path": "/cipherrank"
    }, {
      "name": "排行奖励",
      "path": "/rankactivity"
    }];
    return {
      menuList,
      selectItem: "",
      unsubscribe: null
    };
  },
  computed: {
    ...walletVuex.mapState(["isMobile", "setting"]),
    ...walletVuex.mapGetters(["isWallet"]),
    route() {
      return this.$route.path;
    }
  },
  watch: {},
  methods: {
    onMenu(item) {
      this.selectItem = item;
      this.$router.push(item.path);
    }
  },
  mounted() {
    this.menuList.map(item => {
      if (item.path == this.$route.path) {
        this.selectItem = item;
      }
    });
  }
};